
import { LOCAL_STORAGE_CONSTANTS } from '@/constants/localstorage.contstants'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LeftDrawer',
  props: {
    drawerOpen: {
      type: Boolean,
      required: true
    }
  },
  emits: ['toggled'],
  data() {
    const isEmployeeFlag = localStorage.getItem(LOCAL_STORAGE_CONSTANTS.isEmployee)
    const isEmployee = isEmployeeFlag !== null && isEmployeeFlag === 'true'

    return {
      isEmployee,
      open: false
    }
  },
  watch: {
    drawerOpen(): void {
      this.toggleDrawer()
    }
  },
  mounted() {
    window.addEventListener(LOCAL_STORAGE_CONSTANTS.eventName, this.onLocalStorageChanged)
  },
  unmounted() {
    window.removeEventListener(LOCAL_STORAGE_CONSTANTS.eventName, this.onLocalStorageChanged)
  },
  methods: {
    onLocalStorageChanged(): void {
      const isEmployeeFlag = localStorage.getItem(LOCAL_STORAGE_CONSTANTS.isEmployee)
      this.isEmployee = isEmployeeFlag !== null && isEmployeeFlag === 'true'
    },
    toggleDrawer(): void {
      this.open = !this.open
      this.$emit('toggled', this.open)
    }
  }
})
